export const CREDITO_PJ_ADIANTESA_LOGIN_URL = 'https://adiante-thomsonreuters.lovable.app';
